export default "__VITE_ASSET__C$522oH2__"